import React from 'react';
import FormSection from '../../../FormElements/FormSection';
import Label from '../../../FormElements/Label';
import TextInput from '../../../FormElements/TextInput';
import DropdownList from '../../../FormElements/DropdownList';
import PrimaryButton from '../../../Buttons/PrimaryButton';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class GeneralInfoFormSection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			applicationPurpose: 'New Application',
			taxIdType: '',
			taxId: '',
			taxpayerLegalFirstName: '',
			taxpayerLegalLastName: '',
			tradeDbaName: '',
			businessPhysicalLocationAddress1: 'Property Address 1',
			businessPhysicalLocationAddress2: 'Property Address 2',
			businessPhysicalLocationCity: 'Property Address City',
			businessPhysicalLocationState: 'Property Address State',
			businessPhysicalLocationPostalCode: 'Property Address Zip Code'
		};

		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		console.log('GeneralInfoFormSection', this.props, this.state);
		return (
			<div className="w-full py-4">
				<FormSection>
					<DropdownList
						label="Application Purpose"
						displayLabel={true}
						onChange={this.onChange}
						id="applicationPurpose"
						name="applicationPurpose"
						value={this.state.applicationPurpose}
						data={[
							{
								id: 1,
								name: 'New Application'
							},
							{
								id: 2,
								name: 'Changes to Existing License'
							}
						]}
					/>
					<DropdownList
						label="Tax ID Type *"
						displayLabel={true}
						onChange={this.onChange}
						id="taxIdType"
						name="taxIdType"
						value={this.state.taxIdType}
						data={[
							{
								id: 0,
								name: ''
							},
							{
								id: 1,
								name: 'SSN'
							},
							{
								id: 2,
								name: 'FEIN'
							},
							{
								id: 3,
								name: 'TIN'
							}
						]}
					/>
					<Label htmlFor="taxId">Tax ID *</Label>
					<TextInput
						id="taxId"
						name="taxId"
						value={this.state.taxId}
						onChange={this.onChange}
					/>
					<Label htmlFor="taxpayerLegalFirstName">
						Taxpayer Legal First Name *
					</Label>
					<TextInput
						id="taxpayerLegalFirstName"
						name="taxpayerLegalFirstName"
						value={this.state.taxpayerLegalFirstName}
						onChange={this.onChange}
					/>
					<Label htmlFor="taxpayerLegalLastName">
						Taxpayer Legal Last Name *
					</Label>
					<TextInput
						id="taxpayerLegalLastName"
						name="taxpayerLegalLastName"
						value={this.state.taxpayerLegalLastName}
						onChange={this.onChange}
					/>
					<Label htmlFor="tradeDbaName">Trade Name / DBA</Label>
					<TextInput
						id="tradeDbaName"
						name="tradeDbaName"
						value={this.state.tradeDbaName}
						onChange={this.onChange}
					/>
					{/*<Label htmlFor="businessPhysicalLocationAddress1">
							Address Line 1 *
						</Label>
						<TextInput
							id="businessPhysicalLocationAddress1"
							name="businessPhysicalLocationAddress1"
							value={this.state.businessPhysicalLocationAddress1}
							onChange={this.onChange}
						/>
						<Label htmlFor="businessPhysicalLocationAddress2">
							Address Line 2
						</Label>
						<TextInput
							id="businessPhysicalLocationAddress2"
							name="businessPhysicalLocationAddress2"
							value={this.state.businessPhysicalLocationAddress2}
							onChange={this.onChange}
						/>
						<Label htmlFor="businessPhysicalLocationCity">City *</Label>
						<TextInput
							id="businessPhysicalLocationCity"
							name="businessPhysicalLocationCity"
							value={this.state.businessPhysicalLocationCity}
							onChange={this.onChange}
						/>
						<Label htmlFor="businessPhysicalLocationState">State *</Label>
						<TextInput
							id="businessPhysicalLocationState"
							name="businessPhysicalLocationState"
							value={this.state.businessPhysicalLocationState}
							onChange={this.onChange}
						/>
						<Label htmlFor="businessPhysicalLocationPostalCode">
							Zip Code *
						</Label>
						<TextInput
							id="businessPhysicalLocationPostalCode"
							name="businessPhysicalLocationPostalCode"
							value={this.state.businessPhysicalLocationPostalCode}
							onChange={this.onChange}
						/> */}
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end mb-4 lg:mb-0">
						<SecondaryButton
							label="Continue"
							onClick={() => {
								this.props.continueLocation(
									this.state.applicationPurpose,
									this.state.taxIdType,
									this.state.taxId,
									this.state.taxpayerLegalFirstName,
									this.state.taxpayerLegalLastName,
									this.state.tradeDbaName
								);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}
}
